function Reverb (context, opts) {

  this.inputNode = context.createGain();
  this.reverbNode = context.createConvolver();
  this.outputNode = context.createGain();
  this.wetGainNode = context.createGain();
  this.dryGainNode = context.createGain();

  this.inputNode.connect(this.reverbNode);
  this.reverbNode.connect(this.wetGainNode);
  this.inputNode.connect(this.dryGainNode);
  this.dryGainNode.connect(this.outputNode);
  this.wetGainNode.connect(this.outputNode)

  this._context = context;

  var p = this.meta.params;
  opts = opts || {};
  this._mix       = opts.mix  || p.mix.defaultValue;
  this._time      = opts.time    || p.time.defaultValue;
  this._decay     = opts.decay  || p.decay.defaultValue;
  this._reverse     = opts.reverse  || p.reverse.defaultValue;

  this.dryGainNode.gain.value = this.getDryLevel(this.mix);
  this.wetGainNode.gain.value = this.getWetLevel(this.mix);

  this._buildImpulse();
}

Reverb.prototype = Object.create(null, {

  /**
   * AudioNode prototype `connect` method.
   *
   * @param {AudioNode} dest
   */

  connect: {
    value: function (dest) {
      this.outputNode.connect( dest.input ? dest.input : dest );
    }
  },

  /**
   * AudioNode prototype `disconnect` method.
   */

  disconnect: {
    value: function () {
      this.outputNode.disconnect();
    }
  },

  getDryLevel:  {
    value :function(mix) {
  		if ( mix > 1 || mix < 0)
  			return 0;

  		if (mix <= 0.5)
  			return 1;

  		return 1 - ((mix - 0.5) * 2);
    }
	},

	getWetLevel: {
    value :function(mix) {
  		if ( mix > 1 || mix < 0)
  			return 0;

  		if (mix >= 0.5)
  			return 1;

  		return 1 - ((0.5 - mix) * 2);
  	}
  },

  /**
   * Utility function for building an impulse response
   * from the module parameters.
   */

  _buildImpulse: {
    value: function () {

      var length = this._context.sampleRate * this.time;
	    var impulse = this._context.createBuffer(2, length, this._context.sampleRate);
	    var impulseL = impulse.getChannelData(0);
    	var impulseR = impulse.getChannelData(1);
    	var n, i;

    	for (i = 0; i < length; i++) {
    		n = this._reverse ? length - i : i;
    		impulseL[i] = (Math.random() * 2 - 1) * Math.pow(1 - n / length, this.decay);
    		impulseR[i] = (Math.random() * 2 - 1) * Math.pow(1 - n / length, this.decay);
    	}

      if (this.reverbNode.buffer) {
        this.inputNode.disconnect(this.reverbNode);
        this.reverbNode.disconnect(this.wetGainNode);

        this.reverbNode = this._context.context.createConvolver();
        this.inputNode.connect(this.reverbNode);
        this.reverbNode.connect(this.wetGainNode);
      }

    	this.reverbNode.buffer = impulse;
    }
  },

  /**
   * Module parameter metadata.
   */

  meta: {
    value: {
      name: "Reverb",
      params: {
        mix: {
          min: 0,
          max: 1,
          defaultValue: 0.5,
          type: "float"
        },
        time: {
          min: 0.0001,
          max: 50,
          defaultValue: 0.01,
          type: "float"
        },
        decay: {
          min: 0,
          max: 100,
          defaultValue: 0.01,
          type: "float"
        },
        reverse: {
          min: 0,
          max: 1,
          defaultValue: 0,
          type: "bool"
        }
      }
    }
  },

  /**
   * Public parameters.
   */

   mix: {
     enumerable: true,
     get: function () { return this._mix; },
     set: function (value) {
       this._mix = value;
       this.dryGainNode.gain.value = this.getDryLevel(this.mix);
       this.wetGainNode.gain.value = this.getWetLevel(this.mix);
       this._buildImpulse();
     }
   },

  time: {
    enumerable: true,
    get: function () { return this._time; },
    set: function (value) {
      this._time = value;
      this._buildImpulse();
    }
  },

  decay: {
    enumerable: true,
    get: function () { return this._decay; },
    set: function (value) {
      this._decay = value;
      this._buildImpulse();
    }
  },

  reverse: {
    enumerable: true,
    get: function () { return this._reverse; },
    set: function (value) {
      this._reverse = value;
      this._buildImpulse();
    }
  }

});

/**
 * Exports.
 */

module.exports = Reverb;
